import {_requests, Tag} from '../configuration/index.config';
import {storageService} from './storageService';
import stateMachine from './ClientStateMachine.service';
import logger from './AiLogger';
import loadService from './loadService';
const {UrlDev, wsConfig} = _requests;
const WS_URL = `${UrlDev.WS}${UrlDev.SIA_API_HOST}`;
const {MAX_NUMBER_OF_CONNECTIONS, RECONNECT_DELAY} = wsConfig;

export default class WebSocketService {
    private ws:WebSocket | null = null;
    public sendDataToClient:any = null;
    private siaStore:any = null;
    public isActive = false;
    private isReconnect = true;
    private numberOfTimes = -1;
    private connectionObject:any = null;
    private timerId:any = null;
    private sendDataToComponent:any = null;

    /**
     * initConnection - start connection with websocket
     * @param mode - what mode
     * @param sendDataToClient - call back of sendDataToClient
     * @param firstSend - callback, first task after connection
     */
    initConnection(mode, sendDataToClient, firstSend) {
        const refreshData = storageService.loadFromStorage('refresh');

        if (this.ws) {
            this.ws.close();
            this.ws = null;
        }
        this.connectionObject = {
            mode,
            sendDataToClient,
            firstSend: refreshData && (refreshData.taskName === 'get_project_data' || refreshData.taskName === 'add_listener_channel' || refreshData.taskName === 'add_accuracy_user') ? firstSend : () => {}
        };
        if (mode === Tag.DEFAULT || mode === Tag.LISTEN) {
            this.ws = new WebSocket(`${WS_URL}/${UrlDev.FIRST_ROUTE}/`);
        } else if (mode === Tag.ACCURACY) {
            this.ws = new WebSocket(`${WS_URL}/${UrlDev.ACCURACY_ROUTE}/`);
        } else if (mode === Tag.SEGMENTHOR) {
            this.ws = new WebSocket(`${WS_URL}/${UrlDev.VA_ROUTE}/`);
        } else if (mode === Tag.CLASSIFICATION) {
            this.ws = new WebSocket(`${WS_URL}/${UrlDev.CLASSIFICATION_ROUTE}/`);
        } else if (mode === Tag.DEBUG || Tag.CONFIGURATION) {
            this.ws = new WebSocket(`${WS_URL}/${UrlDev.MANAGEMENT_ROUTE}/`);
        }

        this!.ws!.onerror = async (e) => {
            this.isReconnect = true;
            this.reconnect();
            await logger.sendLog('Error in ws', e, 'error');
        };
        this.ws!.onopen = () => this.initListeners(firstSend);
        this.sendDataToClient = sendDataToClient;
    }

    setWebSocket = (siaStore) => this.siaStore = siaStore;

    /**
     * reconnect - try to reconnect
     */
    reconnect = () => {
        this.ws = null;
        this.isActive = false;
        if (this.isReconnect) {
            !storageService.loadFromStorage('disconnected') && (this.siaStore.wsError = true);
            const {mode, sendDataToClient, firstSend} = this.connectionObject;

            if (this.numberOfTimes < MAX_NUMBER_OF_CONNECTIONS) {
                this.numberOfTimes++;
                this.timerId = setTimeout(() => {
                    if (!this.isActive) {
                        const refreshData = storageService.loadFromStorage('refresh');

                        const firstSendFun = refreshData.taskName === 'get_project_data' && loadService.allDataFromLocal.length > 0 ? () => {} : firstSend;

                        this.initConnection(mode, sendDataToClient, firstSendFun);
                    } else {
                        clearTimeout(this.timerId);
                    }
                }, RECONNECT_DELAY);
            } else {
                clearTimeout(this.timerId);
            }
        } else {
            this.connectionObject = null;
        }
    }

    /**
     * initListeners - init all websocket listeners
     * @param firstSend - callback, first task after connection
     */
    initListeners = (firstSend) => {
        this.isActive = true;
        clearTimeout(this.timerId);
        this.isReconnect = true;
        firstSend();
        this.sendHeartBeat();
        if (this.ws) {
            this.siaStore.wsError = false;
            this!.ws!.onmessage = (dataFromServer) => {
                const data = JSON.parse(dataFromServer.data);

                this.sendDataToClient(data.message);
            };

            this!.ws!.onclose = () => {
                this.reconnect();
            };
        }


    }

    /**
     * sendMessage - send Message to backend
     * @param message - message object
     */
    sendMessage = (message) => {
        this.ws && this.ws!.send(JSON.stringify(message));
    }

    /**
     * closeConnection - close Connection
     */
    closeConnection = (isReconnect = false) => {
        this.isReconnect = isReconnect;
        this.ws?.close();
        this.ws = null;
        this.isActive = false;
    };

    sendHeartBeat = () => {
        const data = {task: 'send_data', 'session_id': stateMachine.getSessionId(), token: storageService.loadFromStorage('token', true), message: {type: 'heartBeat', 'client_id': 'test', 'client_time': new Date().toLocaleString()}};

        this.sendMessage(data);
    }
    setSendDataToComponent = (sendDataToComponent) => this.sendDataToComponent = sendDataToComponent;
    getDataFromWS = (data) => this.sendDataToComponent(data);
}
